import { render, staticRenderFns } from "./ColorsGrid.vue?vue&type=template&id=71979d6b&scoped=true&lang=pug&"
import script from "./ColorsGrid.vue?vue&type=script&lang=ts&"
export * from "./ColorsGrid.vue?vue&type=script&lang=ts&"
import style0 from "./ColorsGrid.vue?vue&type=style&index=0&id=71979d6b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71979d6b",
  null
  
)

export default component.exports